import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { setContact } from '../../../state/contact/contactSlice';
import { setBulkPresence } from '../../../state/presence/presenceSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* fetchContactSaga() {
    try {
        // Fetch user credentials from Redux store
        const { user, domain } = yield select(selectUserCredentials);

        // API endpoint for retrieving contact 
        const apiUrl = '?object=contact&action=read';
        // Parameters for the API call
        const params = {
            user: user,
            domain: domain,
            includeDomain: 'yes'
        }
        // Make the API call with the credentials
        const response = yield call(cirrusClient.get, apiUrl, { params });

        //Formatting contacts to create unique defaultNumber field
        const formattedContacts = response.data.map((contact) => ({
            ...contact,
            defaultNumber:
                contact.user ||
                contact.work_phone ||
                contact.cell_phone ||
                contact.home_phone
        }));

        // Extract initial presence data from contacts and update presence store
        const initialPresence = formattedContacts.reduce((acc, contact) => {
            acc[contact.user] = contact.presence;
            return acc;
        }, {});

        // Set contacts without presence data
        const contactsWithoutPresence = formattedContacts.map(({ presence, ...contact }) => contact);

        yield put(setContact(contactsWithoutPresence));
        yield put(setBulkPresence(initialPresence));

    } catch (error) {
        console.error('Error fetching contacts:', error);
    }


}